// The create screen's tabs, as Jira's create dialog draws them.
//
// A Debtor's create screen (2026-10-15) has two tabs — General (the business
// fields) and Administrative (Trash Reason, Start date, Duration…). The
// create modal flattened them into one list, so the administrative fields sat
// among the business ones. The modal keeps ONE flat field list (what it
// validates and sends) and draws it tab by tab from these groups.

// tabs: the screen layout's [{ name, fields: [{ id }] }]; keep(field) says
// whether the modal draws the field (skipped fields, a Line items table, a
// field out of context). Returns [{ name, ids: [fieldId…] }], in the
// screen's order, without the tabs left empty.
export function createTabs(tabs, keep) {
  const out = [];
  for (const tab of tabs || []) {
    const ids = (tab.fields || []).filter(keep).map((f) => f.id);
    if (ids.length) out.push({ name: tab.name || `Tab ${out.length + 1}`, ids });
  }
  return out;
}

// The tab a field is drawn on (its index), or 0 for a field no tab names.
export function tabOfField(tabs, fieldId) {
  const i = (tabs || []).findIndex((t) => t.ids.includes(fieldId));
  return i < 0 ? 0 : i;
}

// The tabs that hold a required field still empty — marked on the tab bar so
// a demanded field on a tab out of view is not missed.
// isMissing(fieldId) → true when the field is required and has no value.
export function tabsMissing(tabs, isMissing) {
  return (tabs || []).map((t) => t.ids.filter(isMissing).length);
}
